import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

export default ({ id = "tooltip", placement, tooltip, ...props }) => (
  <OverlayTrigger
    overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
    placement={placement}
    delayShow={300}
    delayHide={150}
    trigger={"hover"}
  >
    { props.children }
  </OverlayTrigger>
);


// WEBPACK FOOTER //
// ./src/components/ItemWithTooltip.js